import { autoinject } from 'aurelia-framework';
import { Sortable, SortableSortEvent } from '@shopify/draggable';
import { asyncUtil } from 'lib/helpers';
import { MooringOfferService } from 'services/mooring';
import {
  MooringOfferStatusPipelineItem,
  UpdateMooringOfferStatusContentQueueDto,
  UpdateMooringOfferStatusContentQueueItem,
} from 'models/mooring';
import { ToastService } from 'services/toast-service';

@autoinject
export class BoardViewOffer {
  private mooringOfferStatusPipelines: MooringOfferStatusPipelineItem[] = [];

  private sortable: Sortable | null = null;

  constructor(
    private mooringOfferService: MooringOfferService,
    private toastService: ToastService
  ) {}

  protected async attached() {
    const resposne = await this.mooringOfferService.getBoardData();
    this.mooringOfferStatusPipelines = resposne.data;

    await this.setupSortable();
  }

  private async setupSortable() {
    // Wait for the DOM to be ready before initializing Sortable
    await asyncUtil.wait(200);

    this.sortable?.destroy?.();
    this.sortable = new Sortable(document.querySelectorAll('[sortable]'), {
      draggable: '[sortitem]',
      distance: 35,
    });

    this.sortable.on('sortable:stop', async (event: SortableSortEvent) => {
      try {
        // Ensure DOM is updated before proceeding
        await asyncUtil.wait(200);

        const offerId = event.dragEvent.source.children[0]?.attributes['data-id']?.value;
        if (!offerId) {
          this.toastService.showError('Offer ID is invalid. Cannot update.');
          return;
        }

        const container = event.newContainer;
        const statusId = +(container.id || null);

        const offerElementsInQueye = Array.from(container.querySelectorAll('[sortitem]'));

        const dto = new UpdateMooringOfferStatusContentQueueDto();
        dto.MooringOffers = [];

        let sortIndex = 0;
        offerElementsInQueye.forEach((element) => {
          sortIndex++;
          const offerId = +element.children[0].attributes['data-id'].value;

          const update = new UpdateMooringOfferStatusContentQueueItem();
          update.MooringOfferId = offerId;
          update.SortIndex = sortIndex;

          dto.MooringOffers.push(update);
        });

        await this.mooringOfferService.updateBoardDataPipelineContent(statusId, dto);
        this.toastService.showSuccess('offer.updated');
      } catch (error) {
        this.toastService.showError('An error occurred while updating the offer queue.');
      }
    });
  }
}
